import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import initDirective from "./directive";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import router from "./router";
import "../public/iconfont/iconfont.css";
import "@/styles/style.less";
import "@/utils/flexible";
import "@vant/touch-emulator";
// Toast
import "vant/es/toast/style";
// Dialog
import "vant/es/dialog/style";
// Notify
import "vant/es/notify/style";
// ImagePreview
import "vant/es/image-preview/style";

// import VConsole from "vconsole";
// import { env } from "./store";
// if (env.DEV) new VConsole();

const app = createApp(App);
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

initDirective(app);

app.use(pinia).use(router).mount("#app");
